import * as React from 'react';
import { Column } from "react-table";
import Table from "../../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import type { IModifyRequest } from "./types";
import Page from "../../../components/layout/Page";
import dayjs from "dayjs";
import { STATUSES } from "../constants";
import { useListPage } from "../../../hooks";
import RowActions from "../../../components/table/RowActions";

interface IArtistRecord extends Pick<IModifyRequest, '_id' | 'artistName' | 'songTitle' | 'createdAt' | 'status' | 'songCode1'> {
    actions: unknown;
}

const SongFileRequest = () => {

    const { paginationState, handleInteraction, records, deleteRecord } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<IArtistRecord>[] =  [
        {
            Header: 'Код-1',
            accessor: 'songCode1',
        },
        {
            Header: 'Уран бүтээлч',
            accessor: 'artistName',
        },
        {
            Header: 'Нэр',
            accessor: 'songTitle',
        },
        {
            Header: 'Үүсгэсэн огноо',
            accessor: 'createdAt',
            Cell: (table) => {
                const value = table.row.original.createdAt;
                const date = dayjs(value).format('YYYY-MM-DD HH:ss:mm')
                return (
                    <div>
                        {date}
                    </div>
                )
            }
        },
        {
            Header: 'Төлөв',
            accessor: 'status',
            Cell(table) {
                const value = table.row.original.status;
                return (
                    <div>
                        {STATUSES[value] ?? '-'}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord} />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}/>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default SongFileRequest;